function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["backToTop", "backToTopProps", "children", "className", "dataTestId", "marginTop", "showBackToTop", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import { ThemeContext } from 'styled-components';
import Container from "../Container";
import { ChevronUp } from "../Icon";
import Link from "../Link";
import BackgroundProvider from "../BackgroundProvider";
import StyledFooter, { StyledFooterWrapper, StyledBackToTop, StyledFooterLinkWrapper } from "./styled";
import { useBrand } from "../BrandProvider";
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/footer)
 **/
var Footer = function Footer(_ref) {
  var backToTop = _ref.backToTop,
    backToTopProps = _ref.backToTopProps,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? '06' : _ref$marginTop,
    _ref$showBackToTop = _ref.showBackToTop,
    showBackToTop = _ref$showBackToTop === void 0 ? false : _ref$showBackToTop,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'default' : _ref$width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = React.useContext(ThemeContext) || {};
  var _ref2 = useBrand() || {},
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
  }
  return /*#__PURE__*/React.createElement(StyledFooter, _extends({
    $marginTop: marginTop
  }, getTestAttributes('default'), rest, {
    className: classNames('csl-footer', className)
  }), /*#__PURE__*/React.createElement(Container, {
    width: width
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.footer_color_background
    }
  }, /*#__PURE__*/React.createElement(StyledFooterWrapper, null, /*#__PURE__*/React.createElement(StyledFooterLinkWrapper, {
    className: "csl-footer__wrapper",
    role: "list"
  }, children), backToTop || showBackToTop ? /*#__PURE__*/React.createElement(StyledBackToTop, null, /*#__PURE__*/React.createElement(Link, _extends({
    href: backToTop || '#csl-top',
    icon: /*#__PURE__*/React.createElement(ChevronUp, {
      size: "s2",
      trim: true
    }),
    iconPosition: "right",
    onClick: function onClick(e) {
      if (!backToTop) {
        var firstElementOnPage = document.body.firstElementChild;
        firstElementOnPage === null || firstElementOnPage === void 0 ? void 0 : firstElementOnPage.setAttribute('id', 'csl-top');
      }
    },
    underline: false
  }, backToTopProps), "Back to top")) : null))));
};
Footer.displayName = 'Footer';
export default Footer;